import React, { forwardRef } from 'react';
import clsx from 'clsx';
var ErrorSummary = function (_a) {
    var validationMessages = _a.validationMessages;
    return (React.createElement(React.Fragment, null,
        React.createElement("h2", { className: "text-h4 leading-5 pb-4" },
            "Formul\u00E4ret inneh\u00E5ller ",
            Object.keys(validationMessages).length,
            " fel:"),
        React.createElement("div", { className: "richtext" },
            React.createElement("ul", { className: "mb-0" }, validationMessages &&
                Object.keys(validationMessages).map(function (key, i) { return (React.createElement("li", { key: i },
                    React.createElement("div", { className: "text-p", dangerouslySetInnerHTML: {
                            __html: validationMessages[key].label,
                        } }),
                    React.createElement("span", { className: "text-p" }, " - ",
                        validationMessages[key].message))); })))));
};
var getBorderColor = function (status) {
    switch (status) {
        case 'success':
            return "border-green";
        case 'error':
            return "border-red";
        default:
            return "border-grey";
    }
};
var FormMessage = forwardRef(function (_a, ref) {
    var confirmationMessage = _a.confirmationMessage, state = _a.state;
    var successMessage = state.successMessage, invalidFields = state.invalidFields, serverValidationError = state.serverValidationError, validationMessages = state.validationMessages;
    var hasMessageToShow = confirmationMessage || successMessage;
    var messageType = serverValidationError || invalidFields.length > 0 ? 'error' : 'success';
    return (React.createElement("div", { className: "my-6", hidden: messageType === 'success' && !hasMessageToShow },
        React.createElement("div", { className: clsx('border pt-4 px-4 pb-0', getBorderColor(messageType)), tabIndex: -1, ref: ref },
            (serverValidationError || invalidFields.length > 0) && (React.createElement(ErrorSummary, { validationMessages: validationMessages })),
            confirmationMessage && React.createElement("p", null, confirmationMessage),
            successMessage && (React.createElement("div", { className: "mb-4 text-p", dangerouslySetInnerHTML: { __html: successMessage } })))));
});
export default FormMessage;
